// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1EJJqvXGsrc0UY0MmiNGaZ{flex:1 1 0%}._1JoQ9lkE81B-pZpJVnxe7_{flex:1 1 0%;display:flex;flex-direction:column;align-items:center;padding:5px;border-width:2px;border-radius:2px;border-color:#eeeeee;border-style:dashed;background-color:#fafafa;color:#bdbdbd;outline:none;transition:border .24s ease-in-out}._1JoQ9lkE81B-pZpJVnxe7_:focus{border-color:#2196f3}._1JoQ9lkE81B-pZpJVnxe7_._18kU8j7unFRRGfQFUOIXvw{opacity:0.6}\n", ""]);
// Exports
exports.locals = {
	"dropzoneContainer": "_1EJJqvXGsrc0UY0MmiNGaZ",
	"dropzone": "_1JoQ9lkE81B-pZpJVnxe7_",
	"disabled": "_18kU8j7unFRRGfQFUOIXvw"
};
module.exports = exports;
